import { useEffect, useState } from 'react';
// @mui
import {
  Dialog,
  DialogContent,
  Stack,
  Typography,
  DialogActions,
  Box,
} from '@mui/material';
import { LoadingButton } from "@mui/lab";
import { styled } from '@mui/material/styles';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import Iconify from '../../../components/Iconify';
import DIOText from '../../../components/DIOText';
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const BlueText = styled('span')(({ theme }) => ({
  color: theme.palette.info.main,
  fontWeight: 700,
}));

export default function OutSourcingDialog({ open, outsource, closeDialog }) {
  const smUp = useResponsive('up', 'sm');
  const [submit, setSubmit] = useState(false);

  useEffect(() => {
    if (open) {
      setSubmit(false);
    }
  }, [open]);

  return (
    <Dialog open={open} fullWidth maxWidth="xs">
      <DialogContent sx={{ p: { xs: 3, sm: 4 }, pb: { xs: 0, sm: 0 } }}>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
          <Iconify icon={"eva:info-fill"} sx={{ width: 24, height: 24, color: 'info.main' }} />
        </Stack>
        <Typography
          variant="h5"
          gutterBottom
        >
          <DIOText /> 외주 개발 패키지
        </Typography>
        <Typography
          variant="body1"
          sx={{ wordBreak: "keep-all" }}
          paragraph
        >
          업계 최고 수준의 인력풀로 만족스런 결과물을 받아보실 수 있는 외주 개발 서비스입니다.
        </Typography>
        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            backgroundColor: "grey.200",
          }}
        >
          <Stack spacing={2}>
            <Stack direction="row" alignItems="flex-start" spacing={1}>
              <SvgIconStyle src="/icons/icon-crown-mono.svg" sx={{ minWidth: 20, minHeight: 20, color: "text.disabled" }} />
              <Typography>
                <BlueText>고퀄리티</BlueText> : 기업 고객이 직접 검증한 업계 최고 수준의 개발자, 디자이너로 구성
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="flex-start" spacing={1}>
              <SvgIconStyle src="/icons/icon-chat-bubble-dots-mono.svg" sx={{ minWidth: 20, minHeight: 20, color: "text.disabled" }} />
              <Typography>
                <BlueText>직접 소통 가능</BlueText> : '담당 PM' 과 같은 불필요한 소통 창구 없이, 작업을 진행하는 개발자, 디자이너와 바로 소통 가능
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="flex-start" spacing={1}>
              <SvgIconStyle src="/icons/icon-coin-mono.svg" sx={{ minWidth: 20, minHeight: 20, color: "text.disabled" }} />
              <Typography>
                <BlueText>투명한 견적</BlueText> : 작업자가 직접 제안하는 견적 금액과 <DIOText /> 수수료를 공개
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions sx={{ m: { xs: 0, sm: 1 } }}>
        <Stack justifyContent="flex-end" sx={{ width: 1 }} direction={{ xs: "column-reverse", sm: "row" }} spacing={2}>
          <LoadingButton
            loading={submit}
            size="large"
            sx={{ px: 4 }}
            onClick={closeDialog}
            fullWidth={!smUp}
          >
            취소
          </LoadingButton>
          <LoadingButton
            loading={submit}
            variant="contained"
            size="large"
            sx={{ px: 4 }}
            onClick={() => {setSubmit(true); outsource();}}
            fullWidth={!smUp}
          >
            지금 신청하기
          </LoadingButton>
        </Stack>
      </DialogActions>
    </Dialog>
  )
};
